<template>
  <div class="btn-group ">
    <span v-on:click="eliminarRegistroNovedad(row.id)" class="text-left ml-1 mr-2">
      <!--span class="icon icon-cross iconClose mr-1"></span>
      <span class="textClose ml-1">Quitar</span-->
       <img alt="Eliminar" src="@/assets/images/icons/quitar.svg" /> 
                                   
    </span>
    <span class="pr-1 elipsisCargo ml-1 text-rigth" style="width:100%" v-b-tooltip.hover v-bind:title="row.name">{{ row.name }}</span>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  name: "EditFieldDelete",
  data() {
    return {
      selected: false
    }
  },
  props: ['row','field'],
  computed: {
    ...mapState("modTipshiftReport", ["tipshift","selectAll"]),
      ...mapGetters([
      'modTipshiftReport',
      ["getAllSelected"]
    ]),
  },
  methods: {
    ...mapActions("modTipshiftReport", [
      "actSaveTipshift",
      "actGetTipshift",
      "actGetSelectAll",
      "actSelectRow",
      "actEliminarRegistroNovedad"
    ]),
    
    eliminarRegistroNovedad(id){
      this.actEliminarRegistroNovedad(id);
    },

  },
};
</script>

<style lang="scss" scoped>

</style>